export default __webpack_public_path__ + "static/media/blog.54e4da89.png";